module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', {
    staticClass: "social"
  }, [_c('tooltip', {
    attrs: {
      "label": "Home IoT TF Github",
      "placement": "top-right"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.repository,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fab fa-github fa-lg"
  })])])]), _vm._v("\n         \n        "), _c('tooltip', {
    attrs: {
      "label": "Home IoT TF Confluence",
      "placement": "top-right"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://suprem.sec.samsung.net/confluence/pages/viewpage.action?pageId=103470995",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "far fa-clipboard fa-lg"
  })])])]), _vm._v("\n         \n        "), (_vm.isGroupMember('admin')) ? _c('tooltip', {
    attrs: {
      "label": "Resident API Document",
      "placement": "top-right"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.residentUrl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "far fa-file-alt fa-lg"
  })])])]) : _vm._e(), _vm._v("\n         \n        "), _c('tooltip', {
    attrs: {
      "label": "Device API Document",
      "placement": "top-right"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.deviceUrl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "far fa-file-alt fa-lg"
  })])])])], 1)])])])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b20c872"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"_CLIENT_ID_PLACE_HOLDER_","replace":"lfms21abk334e3i1lnkpr70ep"},{"search":"_BASE_API_PLACE_HOLDER_","replace":"https:/homeiottf-dev.auth.ap-northeast-2.amazoncognito.com"},{"search":"_CALLBACK_URL_HOLDER_","replace":"https:/www.homeiottf.com"}]}!./client/components/layout/FooterBar.vue